import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin } from 'antd'
import TotalAndBar from '@/pages/Bmjy/components/components/TotalAndBar'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'

const tabsOptions = [
  {
    label: '按公司', 
    value: 'ags',
    api: null
  }, 
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const [data1, setData1] = useState([])
  const [data2, setData2] = useState([])
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    loadTime: updateTime
  })

  const mockData = useCallback(() => {
    const d1 = []
    const d2 = []
    for(let i=0; i<12; i++) {
      d1.push({
        "label": i+ 1 + "月",
        "value": Math.floor(Math.random()*100)
      })
      d2.push({
        "label": i+ 1 + "月",
        "value": Math.floor(Math.random()*100)
      })
    }
    setData1(d1)
    setData2(d2)
  }, [])
  
  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.params.tab)
    mockData()
    if(!tabOption || !tabOption.api) {
      return
    }

    const res = await tabOption.api()
    if(res.success) {
      
    }
  }, [mockData])

  // 获取统计数据
  const getTotal = useCallback(async () => {
    
  }, [])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData(), getTotal()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData, getTotal])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    getList()
  }, [getList])

  useEffect(() => {
    if(globalRef.current.loadTime !== updateTime) {
      globalRef.current.loadTime = updateTime
      getList()
    }
  }, [updateTime, getList])

  return (
    <Spin spinning={loading} wrapperClassName='full-spin'>
      <CardContainer
        tabs={tabsOptions}
        onTabChange={handleTabChange}
        title='月度统计'
        hasDepartSelect
      >
        <TotalAndBar
          label1='本年工作量合计（万）'
          value1="9,262.16"
          label2='上年工作量合计（万）'
          value2="6,623.98"
          barData1={data1}
          barLabel1='本年'
          barData2={data2}
          barLabel2='上年'
        />
      </CardContainer>
    </Spin>
  )
}

export default Component
